import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const accountCodeKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'accountCodes'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'accountCodes', itemId] as const,
        detail: [...keys, 'accountCodes', itemId, 'detail'] as const,
        transactionCount: [...keys, 'accountCodes', itemId, 'transactionCount'] as const,
        assignmentCount: [...keys, 'accountCodes', itemId, 'assignmentCount'] as const,
        count: [...keys, 'accountCodes', itemId, 'count'] as const,
      }),
    export: [...keys, 'export'] as const,
  });

export { accountCodeKeys };
